import { Controller } from "@hotwired/stimulus"

// Narrow Service board: the three kanban columns collapse into one
// urgency-ordered list (see _service_kanban.html.erb) and reappear here as
// filter chips over that list. A chip only toggles which already-rendered
// card wrappers are visible — nothing is fetched or removed from the DOM,
// so there's no card a slow request could be hiding, and "All" (the
// default) shows every one of them.
export default class extends Controller {
  static targets = ["chip", "item"]

  select(event) {
    const bucket = event.currentTarget.dataset.bucket
    this.chipTargets.forEach((chip) => {
      chip.classList.toggle("is-active", chip.dataset.bucket === bucket)
    })
    this.itemTargets.forEach((item) => {
      item.classList.toggle("hidden", bucket !== "all" && item.dataset.bucket !== bucket)
    })
  }
}
